import React from "react";
import { useTournamentStore } from '../../../service/useTournamentStore';
import {useGetClubsStatistics, useGetPlayersByAge, useGetPlayersRange, useGetPlayersStatistics, useGetTournamentMetrics} from "../hooks/statisticsHooks";
import HorizontalBarChart, {type BarItem} from "../components/HorizontalBarChart";
import "../dashboard.css";
import {useTranslation} from "react-i18next";
import {MetricsSection} from "../components/MetricsSection";

const TournamentStatistics: React.FC = () => {
    const {selectedTournament} = useTournamentStore();
    const {t} = useTranslation();
    const {data:clubs, isLoading, isError} = useGetClubsStatistics({tournamentId:Number(selectedTournament?.id)});
    const {data:players, isLoading: isPlayerLoading, isError: isPlayerError} = useGetPlayersStatistics({tournamentId:Number(selectedTournament?.id)});
    const {data:metrics, isLoading: isMetricsLoading, isError: isMetricsError} = useGetTournamentMetrics({tournamentId:Number(selectedTournament?.id)});
    const {data:playersRange} = useGetPlayersRange({tournamentId:Number(selectedTournament?.id)});
    const {data:playersByAge} = useGetPlayersByAge({tournamentId:Number(selectedTournament?.id)});
    const barData: BarItem[] = clubs?.map(item => ({
        label: item.label,
        value: item.value
    })) ?? [];

    const barHeight: number = 15;
    const maxVisible:number = 12;

    const playersBar: BarItem[] = players?.map(item => ({
        label: item.playerName,
        value: item.nbMatchs
    })) ?? [];

    const playersRangeBar: BarItem[] = playersRange?.map(item => ({
        label: `${item.min}-${item.max}`,
        value: Number(item.count)
    })) ?? [];

    const playersByAgeBar: BarItem[] = playersByAge?.map(item => ({
        label: t(`AGECATEGORY.${item.ageCategory}`),
        value: Number(item.value)
    })) ?? [];

    return (

        <div className="dashboardWrapper">
            <div className="chartCard">
                <h3 className="chartTitle">{t('statistics.metrics.chart.title')}</h3>
                <MetricsSection metrics={metrics} isLoading={isMetricsLoading} isError={isMetricsError}/>
            </div>

            <div className="chartCard" >
                <h3 className="chartTitle">{t('statistics.clubs.chart.title')}</h3>
                <HorizontalBarChart data={barData} maxVisible={maxVisible} barHeight={barHeight} />
            </div>
            <div className="chartCard" >
                <h3 className="chartTitle">{t('statistics.players.chart.title')}</h3>
                <HorizontalBarChart data={playersBar} maxVisible={maxVisible} barHeight={barHeight} />
            </div>
            <div className="chartCard" >
                <h3 className="chartTitle">{t('statistics.playersRange.chart.title')}</h3>
                <HorizontalBarChart data={playersRangeBar} maxVisible={maxVisible} barHeight={barHeight} />
            </div>
            <div className="chartCard" >
                <h3 className="chartTitle">{t('statistics.playersByAge.chart.title')}</h3>
                <HorizontalBarChart data={playersByAgeBar} maxVisible={maxVisible} barHeight={barHeight} />
            </div>
        </div>
    );
}


export default TournamentStatistics;